/**
 * @owner @Appboy/reporting
 */

export const lineConsumption = "/analytics_dashboard/:app_group_id/line_credit_consumption_detail_data";
